export const SidebarToggleIcon = () => {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="28" height="28" rx="6" fill="white" />
			<path
				d="M12 8V20M9.33333 8H18.6667C19.403 8 20 8.59695 20 9.33333V18.6667C20 19.403 19.403 20 18.6667 20H9.33333C8.59695 20 8 19.403 8 18.6667V9.33333C8 8.59695 8.59695 8 9.33333 8Z"
				stroke="black"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
